<template>
  <v-text-field
    v-model="form.searchTerm"
    flat
    solo-inverted
    hide-details
    prepend-inner-icon="search"
    label="Find User"
    @keyup.enter.native="submit"
  />
</template>

<script>
// import vuex mapping
import { mapActions } from 'vuex'

export default {
  name: 'UserSearchBar',
  data () {
    return {
      form: {
        searchTerm: ''
      }
    }
  },
  methods: {
    ...mapActions({
      searchPeople: 'person/searchPeople'
    }),
    submit  () {
      this.searchPeople(this.form).then(() => {
        this.form.searchTerm = ''
      })
      this.$router.push({ path: '/person/search' })
    }
  }
}
</script>
